import { Add } from '@mui/icons-material';
import {
  Box,
  Button,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import React from 'react';
import { theme } from 'theme';



export type ButtonsProps = {};

export const Buttons = (props: ButtonsProps) => {
  const theme = useTheme();
  const buttonTypes = theme.components?.MuiButton?.variants?.flatMap((node, i) => {
    const colors: any = theme.components?.MuiButton?.styleOverrides;
    return Object.keys(colors)!.map((clr: any, r: number) => (
      <Button
        key={r}
        {...node.props}
        variant={clr}
      >
        {clr}
      </Button>

    ));
  });
  return (
    <>
      {/* {buttonTypes} */}
      <Box>
        <Typography variant='h3'>Primary</Typography>
        <Stack direction='row'>
          <Button variant='contained' color='primary'>
            Contained
          </Button>
          <Button variant='contained' color='primary' startIcon={<Add />}>
            Contained
          </Button>
          <Button variant='outlined' color='primary'>
            Outlined
          </Button>
          <Button variant='text' color='primary'>
            Text
          </Button>
        </Stack>
      </Box>
      <Box>
        <Typography variant='h3'>Secondary</Typography>
        <Stack direction='row'>
          <Button variant='contained' color='secondary'>
            Contained
          </Button>
          <Button variant='contained' color='secondary' startIcon={<Add />}>
            Contained
          </Button>
          <Button variant='outlined' color='secondary'>
            Outlined
          </Button>
          <Button variant='text' color='secondary'>
            Text
          </Button>
        </Stack>


      </Box>
    </>
  );
};


